/**
 * One demand per invoice ID for an account.
 * Comparison ignores surrounding space and letter case.
 */

export function normalizeInvoiceId(value) {
  return String(value ?? '').trim().toLowerCase();
}

export function invoiceIdOf(matter) {
  if (!matter || typeof matter !== 'object') return '';
  return normalizeInvoiceId(
    matter.External_Invoice_ID ?? matter.Invoice_ID ?? matter.externalInvoiceId
  );
}

/**
 * @param {object[]} matters
 * @param {unknown} invoiceId
 * @param {string} [exceptMatterId] demand being edited, so it does not collide with itself
 */
function matterIsDeleted(matter) {
  const flag = matter?.Deleted;
  return flag === true || flag === 1 || flag === '1';
}

export function findDemandWithInvoiceId(matters, invoiceId, exceptMatterId = '') {
  const key = normalizeInvoiceId(invoiceId);
  if (!key) return null;
  const skip = String(exceptMatterId || '');
  for (const matter of matters || []) {
    if (!matter || matterIsDeleted(matter)) continue;
    const id = String(matter.ROWID || matter.id || '');
    if (skip && id === skip) continue;
    if (invoiceIdOf(matter) === key) return matter;
  }
  return null;
}

export function duplicateInvoiceDemandMessage(invoiceId, existing) {
  const shown = String(
    invoiceId || existing?.External_Invoice_ID || existing?.Invoice_ID || ''
  ).trim();
  const demandId = String(existing?.Demand_ID || '').trim();
  const ref = demandId ? ` (${demandId})` : '';
  return `A demand already exists for invoice ${shown}${ref}.`;
}
